import { Component, Vue } from 'vue-property-decorator';
import { CustomBusiness } from '@/models/custom-business.model';
import { BusinessService } from '@/services';

@Component
export default class ThankYouLollyView extends Vue {

    public inFlight: boolean = false;
    public business: CustomBusiness = null;

    public mounted(): void {
        this.getData(this.$route.params.slug);
    }

    private async getData(slug) {
        this.inFlight = true;
        try {
            const response = await BusinessService.publicGet(slug);
            this.business = response.data;
            this.inFlight = false;
            document.title = `${this.business.name} sagt Danke!`;
        } catch (error) {
            console.error('DetailView::getData – failed to business by slug: ', this.$route.params.slug);
            this.inFlight = false;
        }
    }
}
